import axios from 'axios';
import { DownloadListType, LatestDataType, MeasureDataType, PutCommentDataType, SearchDataType } from '../../../common/dist/common';
import { toData } from './base';

export async function search(param: Partial<SearchDataType>) {
  return toData<MeasureDataType[]>(axios.post('/api/data/list', param));
}

export async function getInfo(id: number) {
  return toData<MeasureDataType>(axios.get(`/api/data/info/${id}`));
}

export async function getData(id: number, index: number) {
  return axios.get(`/api/data/chartr/${id}/${index}`, { responseType: 'blob' })
    .then((v) => v.data as Blob);
}

export async function getLatestInfo() {
  return toData<LatestDataType>(axios.get('/api/data/latest/info'));
}

export async function getLatestData(id: number) {
  return axios.get(`/api/data/latest/${id}`, { responseType: 'blob' })
    .then((v) => v.data as Blob);
}

export async function putComment(id: number, comment: PutCommentDataType) {
  return toData<{}>(axios.put(`/api/data/info/comment/${id}`, comment));
}

export async function isMeasure() {
  return toData<boolean>(axios.get('/api/data/measure'));
}

export async function getDownloadList(id: number) {
  return toData<DownloadListType>(axios.get(`/api/data/download/list/${id}`));
}

export default {
  search,
  getInfo,
};
